export default class MailCountCookie {
  constructor() {
    if (!this.vars()) return false;
  }

  vars() {
    this.checkCookie();
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (60*60*1000));
    const expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  checkCookie() {
    let cookie = this.getCookie("ect");
    const d = new Date();
    if (cookie == "") {
      this.setCookie("ect", this.getCookieValue(), 365);
    } else {
      const cookieVal = this.readCookieValue(cookie);
      if (d.getTime() > cookieVal.last + (60*60*1000)) {
        this.setCookie("ect", this.getCookieValue(), 365);
      }
    }
  }

  getCookieValue(increment = false) {
    const d = new Date();
    const obj = {
      sent: !increment ? 0 : increment,
      last: d.getTime(),
    };
    const json = JSON.stringify(obj);
    return btoa(json);
  }

  readCookieValue(value) {
    return atob(value);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Components/MailCountCookie.js